module.exports = __webpack_public_path__ + "static/media/rg-front.1af2d03e.png";